import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d46604b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["alt", "src"]



  /**
   * url: url for href
   * icon: name of to be displayed icon file
   * label: label showing up next to icon
   */
  
export default /*#__PURE__*/_defineComponent({
  __name: 'IconLink',
  props: {
    url: null,
    icon: null,
    label: null
  },
  setup(__props: any) {

const props = __props as {
    url: string;
    icon: string;
    label: string;
  };

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: props.url
  }, [
    _createElementVNode("img", {
      class: "icon-small iconBG color-orange",
      alt: props.label,
      src: require(`../assets/media/icons/${props.icon}`)
    }, null, 8, _hoisted_2),
    _createElementVNode("span", null, _toDisplayString(props.label), 1)
  ], 8, _hoisted_1))
}
}

})